import { configureStore } from '@reduxjs/toolkit';
import attributeItemReducer from './AttributeItemSlice'

// // ローカルストレージに保存するミドルウェアの定義
// const localStorageMiddleware = store => next => action => {
//   // アクションを次のミドルウェア、またはリデューサーに渡す
//   next(action);

//   if(action.type === 'attributeItems/loadAttributeItemData'){
//     // ロード時は何もしない
//     return;
//   }
//   const currentVersion = localStorage.getItem('currentEditorVersion');
//   let editorDatas = localStorage.getItem('editorDatas');
//   editorDatas = JSON.parse(editorDatas);
//   let editorData = editorDatas[currentVersion];

//   editorData.attributeItems = {
//     items: store.getState().attributeItems.items,
//   }
//   editorData.modified = true;
//   editorDatas[currentVersion] = editorData;
//   localStorage.setItem('editorDatas', JSON.stringify(editorDatas));
// };

const attributeItemStore = configureStore({
  reducer: {
    attributeItems: attributeItemReducer
  },
  //middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(localStorageMiddleware),
});

export default attributeItemStore;